// StepSuccess.jsx

import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { fadeUp, stagger } from "../../../../utils/motion";

export default function StepSuccess({ onReset }) {
  return (
    <motion.div
      variants={stagger()}
      initial="hidden"
      animate="show"
      className="max-w-content space-y-8"
    >

      {/* ICON */}
      <motion.div variants={fadeUp} className="flex justify-center">
        <div className="relative flex h-16 w-16 items-center justify-center">

          {/* subtle glow */}
          <div className="absolute inset-0 rounded-full bg-accent-gold/10 blur-xl" />

          <div className="
            relative flex h-14 w-14 items-center justify-center
            rounded-full border border-accent-gold/20
            bg-accent-gold/10 text-accent-gold
          ">
            <CheckCircle2 size={22} />
          </div>

        </div>
      </motion.div>

      {/* TEXT */}
      <motion.div variants={fadeUp} className="space-y-3 text-center">

        <h2 className="text-title font-extrabold text-text-primary">
          Request received
        </h2>

        <p className="mx-auto max-w-reading text-body text-text-muted leading-relaxed">
          We’re preparing your personalised performance report with pricing insights,
          demand trends, and optimisation strategy tailored to your property.
        </p>

      </motion.div>

      {/* DELIVERY CARD */}
      <motion.div
        variants={fadeUp}
        className="
          rounded-[20px]
          border border-border-soft
          bg-bg-light
          p-5 text-center
        "
      >

        <p className="text-small text-text-muted">
          Delivered within
        </p>

        <p className="mt-1 text-body font-semibold text-text-primary">
          24 hours
        </p>

      </motion.div>

      {/* CTA */}
      <motion.button
        variants={fadeUp}
        onClick={onReset}
        className="
          w-full rounded-xl
          border border-border-soft
          px-6 py-3
          font-semibold text-text-primary
          transition hover:bg-bg-light active:scale-[0.99]
        "
      >
        Analyse another property
      </motion.button>

    </motion.div>
  );
}